const MAIN_DOMAIN = 'sendallfiles.com';

// Region code subdomains used for routing to different storage regions
// These should be treated as if there's no subdomain (not custom workspace domains)
const REGION_SUBDOMAINS = ['weur', 'enam', 'apac', 'ocea'];

function getHostname(): string | null {
  if (typeof window === 'undefined' || !window.location) {
    return null;
  }
  return window.location.hostname || null;
}

/**
 * Check if the current hostname is a region subdomain (Cloudflare R2 or Azure region)
 * Region subdomains are used for routing to storage regions and should not make certain API calls
 */
export function isRegionSubdomain(): boolean {
  const hostname = getHostname();
  if (!hostname) {
    return false;
  }

  const normalized = hostname.toLowerCase();

  // Not a region if it's the main domain or www
  if (normalized === MAIN_DOMAIN || normalized === `www.${MAIN_DOMAIN}`) {
    return false;
  }

  // Check if it's a subdomain of sendallfiles.com
  if (normalized.endsWith(`.${MAIN_DOMAIN}`)) {
    const subdomain = normalized.slice(0, normalized.length - MAIN_DOMAIN.length - 1);
    if (subdomain && subdomain !== 'www' && !subdomain.includes('.')) {
      // Check if it's a known region subdomain (R2 regions)
      if (REGION_SUBDOMAINS.includes(subdomain)) {
        return true;
      }
      // Check if it's a 4-character code (Azure regions are all 4 chars)
      // This is a simple heuristic - all region codes are exactly 4 lowercase letters
      if (subdomain.length === 4 && /^[a-z]{4}$/.test(subdomain)) {
        return true;
      }
    }
  }

  return false;
}

export function getCurrentSubdomain(): string | null {
  const hostname = getHostname();
  if (!hostname) {
    return null;
  }

  const normalized = hostname.toLowerCase();

  if (normalized === 'localhost' || normalized === '127.0.0.1') {
    try {
      const testSubdomain = localStorage.getItem('subdomain');
      if (testSubdomain && testSubdomain.trim()) {
        return testSubdomain.trim().toLowerCase();
      }
    } catch {
      // localStorage may be unavailable (Safari private mode, etc.)
    }
    return null;
  }

  if (normalized === MAIN_DOMAIN || normalized === `www.${MAIN_DOMAIN}`) {
    return null;
  }

  if (normalized.endsWith(`.${MAIN_DOMAIN}`)) {
    const subdomain = normalized.slice(0, normalized.length - MAIN_DOMAIN.length - 1);
    if (subdomain && subdomain !== 'www' && !subdomain.includes('.')) {
      // Filter out region code subdomains - treat them as if there's no subdomain
      if (REGION_SUBDOMAINS.includes(subdomain)) {
        return null;
      }
      return subdomain;
    }
  }

  return null;
}

export function isMainSendAllFilesDomain(): boolean {
  const hostname = getHostname();
  if (!hostname) return false;
  const normalized = hostname.toLowerCase();
  return normalized === MAIN_DOMAIN || normalized === `www.${MAIN_DOMAIN}`;
}
